import type { ReactNode } from 'react';
import { MessageBody } from './MessageBody.js';
import { bubble } from './tokens.js';

/**
 * Bulle de message (garage et portail, vague 4) : une couleur par auteur (jetons
 * `--color-author-garage-*` et `--color-author-customer-*`), la même des deux côtés ; alignée à
 * droite pour « moi » (le garage côté garage, le client côté portail), à gauche pour l'autre.
 */
export function MessageBubble({
  author,
  mine,
  meta,
  body,
  children,
}: {
  author: 'garage' | 'customer';
  mine: boolean;
  meta: ReactNode;
  body: string;
  children?: ReactNode;
}) {
  return (
    <li className={`flex ${mine ? 'justify-end' : 'justify-start'}`} data-author={author}>
      <div className={`max-w-[85%] rounded-2xl px-4 py-3 ${mine ? 'rounded-br-sm' : 'rounded-bl-sm'} ${bubble[author]}`}>
        <MessageBody text={body} />
        {children}
        <p className="mt-1 text-xs opacity-80">{meta}</p>
      </div>
    </li>
  );
}
